module.exports = __webpack_public_path__ + "static/media/light8.1632cf8b.png";